import { defineMessages } from 'react-intl';

export default defineMessages({
	passwordInvalid: {
		id: 'password.invalid.password.size',
		description: 'Displayed when the user has entered a password shorter than 8 characters',
		defaultMessage: 'Password must have at least 8 characters',
	},
	passwordStrengthLevel0: {
		id: 'password.strength.level.0',
		description: 'Displayed when the user has entered a weak password',
		defaultMessage: 'Weak',
	},
	passwordStrengthLevel1: {
		id: 'password.strength.level.1',
		description: 'Displayed when the user has entered a fair (not very good) password',
		defaultMessage: 'Fair',
	},
	passwordStrengthLevel2: {
		id: 'password.strength.level.2',
		description: 'Displayed when the user has entered a good password',
		defaultMessage: 'Good',
	},
	passwordStrengthLevel3: {
		id: 'password.strength.level.3',
		description: 'Displayed when the user has entered a strong password',
		defaultMessage: 'Strong',
	},
	passwordStrengthLevel4: {
		id: 'password.strength.level.4',
		description: 'Displayed when the user has entered a very strong password',
		defaultMessage: 'Very strong',
	},
	passwordStrengthUnavailable: {
		id: 'password.strength.unavailable',
		description: 'Displayed when the password strength cannot be determined due to an error',
		defaultMessage: 'Password strength unavailable',
	},
});
